// MasalSensin — swipe-to-change-image inside Dwell zoom dialog
// Aggressively intercepts horizontal swipes before Dwell's close handlers fire.
(function () {
  var SWIPE_THRESHOLD = 40;
  var HORIZ_BIAS = 1.3; // |dx|/|dy| must exceed this to count as horizontal
  var MOVE_INTERCEPT = 10; // after this many px horizontal, capture & suppress propagation

  function thumbClickAt(dialog, idx) {
    var thumbs = dialog.querySelectorAll('[ref="thumbnails"] > *');
    if (!thumbs.length) thumbs = dialog.querySelectorAll('.dialog-zoomed-gallery__thumbnails > *');
    if (!thumbs.length) thumbs = dialog.querySelectorAll('nav button[aria-label*="slide"], nav [role="button"]');
    if (!thumbs || !thumbs[idx]) return false;
    var el = thumbs[idx];
    (el.querySelector('a, button') || el).click();
    return true;
  }

  function currentIdx(dialog) {
    var thumbs = dialog.querySelectorAll('[ref="thumbnails"] > *');
    var idx = -1;
    thumbs.forEach(function (t, i) {
      if (t.matches('[aria-current="true"], [aria-current="page"], .is-active, .active, [data-active="true"]')) idx = i;
      if (idx === -1 && t.querySelector('[aria-current="true"]')) idx = i;
    });
    if (idx < 0) {
      var scroller = dialog.querySelector('.dialog-zoomed-gallery');
      if (scroller && scroller.clientWidth > 0) {
        idx = Math.round(scroller.scrollLeft / scroller.clientWidth);
      }
    }
    return idx < 0 ? 0 : idx;
  }

  function attach(dialog) {
    if (!dialog || dialog.__msSwipeAttached2) return;
    dialog.__msSwipeAttached2 = true;

    var startX = 0, startY = 0, active = false, intercepted = false;

    function onDown(e) {
      var t = e.touches ? e.touches[0] : e;
      if (!t) return;
      startX = t.clientX; startY = t.clientY;
      active = true; intercepted = false;
    }
    function onMove(e) {
      if (!active) return;
      var t = e.touches ? e.touches[0] : e;
      if (!t) return;
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (!intercepted && Math.abs(dx) > MOVE_INTERCEPT && Math.abs(dx) > Math.abs(dy) * HORIZ_BIAS) {
        intercepted = true;
      }
      if (intercepted) {
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        if (e.cancelable) e.preventDefault();
      }
    }
    function onUp(e) {
      if (!active) return;
      active = false;
      var t = (e.changedTouches && e.changedTouches[0]) || e;
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      var wasHoriz = Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy) * HORIZ_BIAS;
      if (intercepted) {
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        if (e.cancelable) e.preventDefault();
      }
      if (wasHoriz) {
        var idx = currentIdx(dialog);
        var thumbs = dialog.querySelectorAll('[ref="thumbnails"] > *');
        var len = thumbs.length || 999;
        var next = dx < 0 ? Math.min(idx + 1, len - 1) : Math.max(idx - 1, 0);
        if (next !== idx) thumbClickAt(dialog, next);
      }
      intercepted = false;
    }

    // capture phase = run BEFORE Dwell's handlers (which are likely on the dialog or internal scroller)
    dialog.addEventListener('touchstart', onDown, { capture: true, passive: true });
    dialog.addEventListener('touchmove',  onMove, { capture: true, passive: false });
    dialog.addEventListener('touchend',   onUp,   { capture: true, passive: false });
    dialog.addEventListener('touchcancel', function(){ active = false; intercepted = false; }, { capture: true });
  }

  function scan() {
    document.querySelectorAll('zoom-dialog, zoom-dialog dialog, .dialog-zoomed-gallery__dialog').forEach(attach);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
